import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_ACCOUNTS, 

    ADD_NEW_ACCOUNT, 

    UPDATE_ACCOUNT, 

    CHANGE_PASSWORD,

    DELETE_ACCOUNT, 

 

    SEND_INVITATION,

    RESEND_INVITATION,

    ACCEPT_INVITATION,

    RESEND_INVITATION_CODE,

    CREATE_PASSWORD,

    LOCK_ACCOUNT,

    UNLOCK_ACCOUNT,

    ENABLE_TWO_FACTOR,

    DISABLE_TWO_FACTOR,

    VERIFY_TWO_FACTOR,
    RESEND_TWO_FACTOR_CODE,

} from "./actionTypes";

import {
    getAccountsSuccess,
    getAccountsFail,

    addAccountSuccess,
    addAccountFail,

    updateAccountSuccess,
    updateAccountFail,

    changePasswordSuccess,
    changePasswordFail,


    deleteAccountSuccess,
    deleteAccountFail,



    // SEND INVITATION
    sendInvitationSuccess,
    sendInvitationFail,

    // RESEND INVITATION
    resendInvitationSuccess,
    resendInvitationFail,

    // ACCEPT INVITATION
    acceptInvitationSuccess,
    acceptInvitationFail,

    // RESEND INVITATION CODE
    resendInvitationCodeSuccess,
    resendInvitationCodeFail,

    // CREATE PASSWORD
    createPasswordSuccess,
    createPasswordFail,

    // LOCK ACCOUNT
    lockAccountSuccess,
    lockAccountFail,

    // UNLOCK ACCOUNT
    unlockAccountSuccess,
    unlockAccountFail,

    // ENABLE TWO FACTOR
    enableTwoFactorSuccess,
    enableTwoFactorFail,

    // DISABLE TWO FACTOR
    disableTwoFactorSuccess,
    disableTwoFactorFail,

    // VERIFY 2FA
    verifyTwoFactorSuccess,
    verifyTwoFactorFail,

    resendTwoFactorCodeSuccess,
    resendTwoFactorCodeFail,
   
} from "./actions"

import {
    getAccounts,

    addNewAccount,

    updateAccount,

    changePassword,

    deleteAccount,

  
    

    sendInvitation,

    resendInvitation,

    acceptInvitation,

    resendInvitationCode,

    createPassword,

    lockAccount,

    unlockAccount,

    enableTwoFactor,

    disableTwoFactor,
    verifyTwoFactor,
    resendTwoFactorCode

   
} from "helpers/accounts/accounts_backend_helper";
import { toast } from "react-toastify";

function* fetchAccounts() {
    try {
        const response = yield call(getAccounts)
        yield put(getAccountsSuccess(response))
    } catch (error) {
        yield put(getAccountsFail(error))
    }
}

function* onAddNewAccount({ payload: data }) {
    try {
        const response = yield call(addNewAccount, data)
        yield put(addAccountSuccess(response))
        toast.success("Account  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addAccountFail(error))
        toast.error("Account  Added Failed", { autoClose: 2000 });
    }
}


function* onUpdateAccount({ payload: data }) {
    try {
        const response = yield call(updateAccount, data)
        yield put(updateAccountSuccess(response))
        toast.success("Account  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateAccountFail(error))
        toast.error("Account  Updated Failed", { autoClose: 2000 });
    }
}

function* onChangePassword({ payload: data }) {
    try {
        const response = yield call(changePassword, data)
        yield put(changePasswordSuccess(response))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(changePasswordFail(error))
        toast.error(error.response?.data?.error, { autoClose: 2000 });
    }
}

function* onDeleteAccount({ payload: data }) {
  

    try {
        const response = yield call(deleteAccount, data)
        yield put(deleteAccountSuccess(response.accountId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteAccountFail(error))
        toast.error(error.response.error, { autoClose: 2000 });
    }
}




// SEND INVITATION

function* onSendInvitation({ payload: data }) {
    try {
        const response = yield call(sendInvitation, data)

       
        yield put(sendInvitationSuccess(response.account))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERORRRRR: ", error.response.data.error);
        yield put(sendInvitationFail(error))
        toast.error( error.response.data.error, { autoClose: 2000 });
    }
}

// RESEND INVITATION

function* onResendInvitation({ payload: data }) {
    try {
        const response = yield call(resendInvitation, data)

     
        yield put(resendInvitationSuccess(response))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        
        yield put(resendInvitationFail(error))
        toast.error( error.response.data.error, { autoClose: 2000 });
    }
}



// ACCEPT INVITATION
function* onAcceptInvitation({ payload: { code, history } }) {
    try {
        const response = yield call(acceptInvitation, code)

        console.log("RESPONSE: #", response.token);
         localStorage.setItem("reset_password_token", JSON.stringify(response.token));
         //const token = localStorage.getItem('yeta_reset_token');

         console.log("TOKENI: ", localStorage.getItem("reset_password_token"));
        yield put(acceptInvitationSuccess(response.account))
        toast.success(response.message, { autoClose: 2000 });
         history("/password/reset");

       

       

    } catch (error) {
        //console.log("ERORRRRR: ", error.response.data.error);
        yield put(acceptInvitationFail(error))
        if (error.response){
        toast.error( error.response.data.error, { autoClose: 2000 });
        }
    }
    
}

// RESEND INVITATION CODE
function* onResendInvitationCode({ payload: token }) {
    try {
        console.log("CODE BEFORE SEND", token);
        const response = yield call(resendInvitationCode, token);
        yield put(resendInvitationCodeSuccess(response));
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        const errorMessage = error.response?.data?.message || "Erreur lors du renvoi du code.";
        yield put(resendInvitationCodeFail(errorMessage));
        toast.error(errorMessage);
    }
}

// CREATE PASSWORD
function* onCreatePassword({ payload }) {
    try {

        console.log("SAGA START");
                const { data, history } = payload;
                console.log("BEFORE API CALL");

        const response = yield call(createPassword, data)
        console.log("AFTER API CALL", response);
        //localStorage.removeItem('yeta_reset_token');
         history("/login");
        yield put(createPasswordSuccess(response))
        toast.success(response, { autoClose: 2000 });
    } catch (error) {

        console.log("SAGA ERROR:", error);
    console.log("ERROR RESPONSE:", error.response);
    
        //yield put(addAccountFail(error))
         yield put(createPasswordFail(error)); // ✅ pas addAccountFail
        toast.error(error, { autoClose: 2000 });
    }
}

// LOCK ACCOUNT
function* onLockAccount({ payload: account }) {
  try {
    const response = yield call(lockAccount, account);
    //yield put(lockAccountSuccess(response));
    yield put(lockAccountSuccess({ uid: account.uid }));



    toast.success(response.message, { autoClose: 2000 });
  } catch (error) {
    const msg = error.response?.data?.error || "Erreur lors du changement d’état du compte";
    yield put(lockAccountFail(msg));
    toast.error(msg, { autoClose: 2000 });
  }
}

// UNLOCK ACCOUNT
function* onUnlockAccount({ payload: account }) {
  try {
    const response = yield call(unlockAccount, account);
    //yield put(unlockAccountSuccess(response));
    yield put(unlockAccountSuccess({ uid: account.uid }));



    toast.success(response.message, { autoClose: 2000 });
  } catch (error) {
    const msg = error.response?.data?.error || "Erreur lors du changement d’état du compte";
    yield put(unlockAccountFail(msg));
    toast.error(msg, { autoClose: 2000 });
  }
}


// ENABLE TWO FACTOR
function* onEnableTwoFactor({ payload: account }) {
  try {
    const response = yield call(enableTwoFactor, account);
    //yield put(unlockAccountSuccess(response));
    yield put(enableTwoFactorSuccess());



    toast.success(response.message, { autoClose: 2000 });
  } catch (error) {
    const msg = error.response?.data?.error ;
    yield put(enableTwoFactorFail(msg));
    toast.error(msg, { autoClose: 2000 });
  }
}

// DISABLE TWO FACTOR
function* onDisableTwoFactor({ payload: account }) {
  try {
    const response = yield call(disableTwoFactor, account);
    //yield put(unlockAccountSuccess(response));
    yield put(disableTwoFactorSuccess());



    toast.success(response.message, { autoClose: 2000 });
  } catch (error) {
    const msg = error.response?.data?.error ;
    yield put(disableTwoFactorFail(msg));
    toast.error(msg, { autoClose: 2000 });
  }
}

// VERIFY 2FA
// payload: { code, tempToken, history }
function* onVerifyTwoFactor({ payload }) {
  const { code, tempToken, history } = payload;

  try {
    if (!tempToken) throw new Error("Token temporaire manquant. Veuillez vous reconnecter.");

    // Appel API pour valider le code 2FA
    const response = yield call(verifyTwoFactor, { temp_token: tempToken, code });

    // Stockage final du compte + access_token
    localStorage.setItem("authUser", JSON.stringify(response));
    localStorage.removeItem("tempToken"); // 2FA terminé
    //localStorage.removeItem("twoFactor");

    yield put(verifyTwoFactorSuccess(response));

    // Redirection vers dashboard
    history("/dashboard");

  } catch (error) {
    // Toujours passer une string pour éviter les erreurs React
    const message = error.response?.data?.error || error.message || "Une erreur est survenue";
    yield put(verifyTwoFactorFail(message));
    yield put(apiError(message));
  }
}

// RESEND  TWO FACTOR CODE
function* onResendTwoFactorCode({ payload: temp_token }) {
    try {
       
        const response = yield call(resendTwoFactorCode, temp_token);

        localStorage.setItem("tempToken", response.temp_token); // stockage temporaire

        yield put(resendTwoFactorCodeSuccess(response));
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        const errorMessage = error.response?.data?.error || "Erreur lors du renvoi du code.";
        yield put(resendTwoFactorCodeFail(errorMessage));
        toast.error(errorMessage);
    }
}

function* accountSaga() {
    yield takeEvery(GET_ACCOUNTS, fetchAccounts)
    yield takeEvery(ADD_NEW_ACCOUNT, onAddNewAccount)
    yield takeEvery(UPDATE_ACCOUNT, onUpdateAccount)
    yield takeEvery(CHANGE_PASSWORD, onChangePassword)
    yield takeEvery(DELETE_ACCOUNT, onDeleteAccount)
    yield takeEvery(SEND_INVITATION, onSendInvitation)
    yield takeEvery(RESEND_INVITATION, onResendInvitation)
    yield takeEvery(ACCEPT_INVITATION, onAcceptInvitation)
    yield takeEvery(RESEND_INVITATION_CODE, onResendInvitationCode)
    yield takeEvery(CREATE_PASSWORD, onCreatePassword)
    yield takeEvery(LOCK_ACCOUNT, onLockAccount)
    yield takeEvery(UNLOCK_ACCOUNT, onUnlockAccount)
    yield takeEvery(ENABLE_TWO_FACTOR, onEnableTwoFactor)
    yield takeEvery(DISABLE_TWO_FACTOR, onDisableTwoFactor)
    yield takeEvery(VERIFY_TWO_FACTOR, onVerifyTwoFactor)
    yield takeEvery(RESEND_TWO_FACTOR_CODE, onResendTwoFactorCode)
}

export default accountSaga;